import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

import RemarksSetup from "../../components/setup/RemarkSetup/RemarksSetup";
 
const RemarkSetupPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Remark Setup</VolunteerHeading>
      <RemarksSetup />
    </MainDiv>
  );
};
export default RemarkSetupPage;
